export default "__VITE_ASSET__D4EW7L4I__"